const en = {
  language: "Language",
  english: "English",
  portuguese: "Portuguese",
  spanish: "Spanish",
  logout: "Logout",
  loginPage: "Login",
  login: "Login",
  welcome: "Welcome",
  save: "Save",
  backToSearch: "Back to search",
  backToDetails: "Back to details",
  delete: "Delete",
  update: "Update",
  edit: "Edit",
  new: "New",
  newA: "New",
  search: "Search",
  total: "Total",
  itensFound: "items found",
  registersPerPage: "registers per page",
  ofPages: "of {0} pages",
  yes: "Yes",
  no: "No",
  select: "Select",
  name: "Name",
  code: "Code",
  close: "Close",
  date: "Date",
  user: "User",
  details: "Details",
  email: "E-mail",
  column: "Column",
  warning: "Warning",
  menu: "Menu",
  form: "Form",
  itemSuccessfullyCreated: "Item successfully created",
  itemSuccessfullyUpdated: "Item successfully updated",
  confirmTheDeletion: "Do you confirm the deletion?",
  itemDeleted: "Item deleted.",
  error: "Error",
  unexpectedError: "Unexpected error!",
  anUnexpectedErrorOccurred: "An unexpected error occurred:",
  theUrlAccessedDoesNotBelongToAnyTenant: "The url accessed does not belong to any Tenant",
  success: "Success",
  value: "Value",
  label: "Label",
  maximumSize: "Maximum size",
  maximumValue: "Maximum value",
  minimumSize: "Minimum size",
  minimumValue: "Minimum value",
  required: "Required",
  suffix: "Suffix",
  users: "Users",
  backToList: "Back to list",
  phone: "Phone",
  enabled: "Enabled?",
  noItemsFound: "No items found",
  item: "Item",
  contactUs: "Contact us",
  cpf: "CPF",
  cnpj: "CNPJ",
  invalid: "invalid",
  pleaseFillInTheField: "Please, fill in the field",
  bothFieldsAreRequired: "Both fields are required!",
  profile: "Profile",
  changePassword: "Change password",
  currentPassword: "Current password",
  newPassword: "New password",
  repeatNewPassword: "Repeat new password",
  passwordExpired: 'Password expired',

  username: "Username",
  password: "Password",
  documentNumber: "Document number",
  actions: 'Actions',
  chooseAFile: 'Choose a file.',
  version: 'Version',
  sgs_render_file_error_upload: "An error occurred, the file was not uploaded"
};

export default {
  ...en
};



// WEBPACK FOOTER //
// ./src/i18n/en.js